export type ClassValue = string | false | null | undefined;

/** Minimal class-name joiner. Not published as a dependency: it is one line. */
export function cx(...values: readonly ClassValue[]): string {
  return values.filter(Boolean).join(' ');
}
